<template>
  <div class="Action-form Action-form--attachment">
    <div class="Grid--beta">
      <div class="Grid__col Grid__col--12 Action-form__inner">
        <div v-if="action.description" class="Action-form__description">
          <vue-markdown
            class="Action-form__inner__description"
            :postrender="addClasses"
            >{{ action.description }}</vue-markdown
          >
        </div>
        <UploadInput
          :fileName="action.attachmentFileName"
          :fileUrl="action.attachmentUrl"
          :allowed-file-types="['pdf']"
          :max-file-size="50000000"
          @touch="resizeExpander"
          @input="handleChangeFile"
          @remove="handleRemoveFile"
          @download="onFileDownload"
          :downloading="downloadIsLoading"
          :disabled="isDisabled"
        />
        <p v-if="action.attachmentUrl">
          <em class="Action-form__info">En fil har laddats upp</em>
        </p>
      </div>
    </div>
    <div class="Grid--beta">
      <div class="Grid__col Grid__col--12">
        <div v-if="action.name == 'SKV 4820'" class="Action-form__top__toolbox">
          Vad är detta?
          <div class="Toolbox Toolbox--attachment">
            <div class="Toolbox__notes">
              <p class="Toolbox__notes__desc">{{ toolboxText() }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isApplicant" class="Action-form__controls">
      <ToggleInput
        :value="approved"
        :disabled="!action.isValid || !isDisabled"
        text="Godkänd bilaga"
        @input="handleChangeApproved"
      />
      <div v-if="!approved">
        <button
          v-if="submitted"
          class="Button Button--secondary"
          @click="unlockAction"
        >
          Lås upp för komplettering
        </button>
        <button v-else class="Button Button--primary" @click="lockAction">
          Avsluta komplettering
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import { EventBus } from "@/services/event-bus";
import UploadInput from "@/components/forms/UploadInput";
import ToggleInput from "@/components/forms/ToggleInput";
import VueMarkdown from "vue-markdown";
import { saveAs } from "file-saver";

export default {
  name: "ApplicationActionAttachment",
  components: { UploadInput, ToggleInput, VueMarkdown },
  data() {
    return {
      downloadIsLoading: false
    };
  },
  props: {
    action: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("memberStore", ["isApplicant"]),
    ...mapState("applicationStore", ["application"]),
    approved() {
      return this.action.status === "APPROVED";
    },
    submitted() {
      return this.action.status === "IN_REVIEW";
    },
    isDisabled() {
      return this.submitted || this.approved;
    }
  },
  methods: {
    ...mapActions("applicationStore", [
      "approveAction",
      "submitAction",
      "uploadAttachment",
      "removeAttachment",
      "getFileForAction"
    ]),
    handleChangeFile(files) {
      if (files && files.length && files[0] && !this.disabled) {
        this.uploadAttachment({
          actionId: this.action.id,
          file: files[0]
        });
      }
    },
    handleRemoveFile() {
      this.removeAttachment({
        actionId: this.action.id
      });
    },
    handleChangeApproved(isChecked) {
      this.approveAction({
        actionId: this.action.id,
        approved: isChecked
      });
    },
    resizeExpander() {
      EventBus.$emit("expander:resize");
    },
    toolboxText() {
      if (this.action.name === "SKV 4820") {
        return "SKV 4820 är en handling som visar att skatter och avgifter är inbetalda för närmast föregående tre månader samt eventuella skulder hos kronofogden. Du som är företagare (eller behörigt ombud) kan logga in på Skatteverkets Mina Sidor och hämta en ifylld blankett SKV 4820, inklusive restförd skatteskuld enligt Skatteverkets register.";
      }
    },
    addClasses(html) {
      const replaceAll = new RegExp("<li>", "g");
      return html
        .replace("<h1>", '<p class="Action-form__header">')
        .replace("<h2>", '<p class="Action-form__header">')
        .replace("<ul>", '<ul class="Action-form__list">')
        .replace(replaceAll, '<li class="Action-form__list__item">');
    },
    unlockAction() {
      this.submitAction({
        actionId: this.action.id,
        submitted: false
      });
    },
    lockAction() {
      this.submitAction({
        actionId: this.action.id,
        submitted: true
      });
    },
    onFileDownload(fileName) {
      if (!this.downloadIsLoading) {
        this.downloadIsLoading = true;
        this.getFileForAction({
          actionId: this.action.id
        }).then(response => {
          this.downloadIsLoading = false;
          let blob = new Blob([response], { type: "application/pdf" });
          saveAs(blob, `${fileName}`);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
